const FilterValues = {
    NONE: '0',
};

export { FilterValues };